export default __webpack_public_path__ + "static/media/Desktop_2.b2cf1f45.jpg";